import { useFlag as useTgglFlag } from 'react-tggl-client';

export enum Flag {
  ANALYSIS_WINDOW_CONFIGURATION = 'analysis_window_configuration',
  ANALYSIS_WINDOW_CONFIGURATION_OLD_VERSION = 'analysis_window_configuration_old_version',
  INDICATOR_SECTION_IS_KILLED = 'indicator_section_is_killed',
  SETTINGS_USERS_TAB_IS_KILLED = 'settings_users_tab_is_killed',
  NUMBER_OF_LICENSES = 'number_of_licenses',
  UPDATED_ERROR_MESSAGE = 'updated_error_message',
  SMS_INVITATION = 'sms_invitation',
  EMAIL_INVITATION = 'email_invitation',
  BANK_TRANSACTIONS_TO_BE_JUSTIFIED_INDICATOR = 'bank_transactions_to_be_justified_indicator',
  HIDE_EXPORT_BUTTON = 'hide_export_button',
  HIDE_STATEMENTS_TAB = 'hide_statements_tab',
  INVITATION_HIDE_AUTOMATIC_SENDING_SECTION = 'invitation_hide_automatic_sending_section',
  INVITATION_HIDE_FIRSTNAME_AND_LASTNAME = 'invitation_hide_firstname_and_lastname',
  INVITATION_HIDE_EMAIL = 'invitation_hide_email',
  INVITATION_HIDE_PHONE_NUMBER = 'invitation_hide_phone_number',
  INVITATION_HIDE_CO_BORROWER = 'invitation_hide_co_borrower',
  HIDE_THE_TRANSACTIONS = 'hide_the_transactions',
  HIDE_THE_TUTORIAL = 'hide_the_tutorial',
  JWS_FOR_CFCAL = 'jws_for_cfcal',
  SCORE_INDICATORS = 'score_indicators',
  PDF_DEMO = 'pdf_demo',
  ACTIVE_EXPORT_BUTTON_FOR_DASHBOARD = 'active_export_button_for_dashboard',
}

export const useFeatureFlag = (flagName: Flag): ReturnType<typeof useTgglFlag> => {
  const flagData = useTgglFlag(flagName);

  return flagData;
};
